import CrudBase from '../../CrudBase';
import axios from '../../../axios-common';

class DuplicatesApi extends CrudBase {

  getDuplicates = (params) => axios.get(`${this.endpoint}/get-by`, params);

  defaultMethods = {
    ...this.defaultMethods,
    getDuplicates: this.getDuplicates,
  }
}

const duplicate = new DuplicatesApi('/api/v1/open-duplicate');

export default duplicate.defaultMethods;

